module.exports = __webpack_public_path__ + "static/testimonial-thumb-6-115e244e24d299678be2a20129808818.jpg";